import HeroSlider, { ButtonsNav, Nav, OverlayContainer, Slide } from 'hero-slider';

import React from 'react';

const app = props => {
  return (
    <React.Fragment>
      {props.activeDotColor && (
        <style>
          .ewavzl .slide-nav-active-button {'{'}
          background-color: {props.activeDotColor} !important;
          {'}'}
        </style>
      )}
      <HeroSlider
        orientation="horizontal"
        initialSlide={1}
        // onBeforeChange={(previousSlide, nextSlide) =>
        //   console.log('onBeforeChange', previousSlide, nextSlide)
        // }
        // onChange={nextSlide => console.log('onChange', nextSlide)}
        // onAfterChange={nextSlide => console.log('onAfterChange', nextSlide)}
        style={{
          backgroundColor: '#000',
        }}
        settings={{
          slidingDuration: 1000,
          slidingDelay: 100,
          shouldAutoplay: true,
          shouldDisplayButtons: props.shouldDisplayButtons ? props.shouldDisplayButtons : false,
          autoplayDuration: 4000,
          height: props.height ? props.height : '100vh',
          shouldSlideOnArrowKeypress: true,
        }}
        className="hero-slider-height"
      >
        {/* <OverlayContainer>
        <Wrapper>
          <Title>Zoom Slider</Title>
          <Subtitle>
            Slides' backgroundAnimation prop set to 'zoom' (you may reload the page if it's already
            over)
          </Subtitle>
        </Wrapper>
      </OverlayContainer> */}

        {props.slides &&
          props.slides.map((val, index) => {
            return (
              <Slide
                Key={index}
                // navDescription="desc1"
                background={{
                  backgroundSize: 'cover',
                  backgroundImage: val,
                  backgroundAnimation: 'zoom',
                }}
              />
            );
          })}

        {/* <ButtonsNav
        isNullAfterThreshold
        position={{
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      /> */}
        <Nav />
      </HeroSlider>
    </React.Fragment>
  );
};

export default app;



// WEBPACK FOOTER //
// ./src/features/themes/common/ZoomSlider/ZoomSlider.js